import { Outlet } from "react-router-dom";
import { useAppAbility } from "@/casl";
import { Restricted } from "@/components/pages";
import { ContractPricingProfilesContextProvider } from "./ContractPricingProfilesContext";

export const ContractPricingProfilesRoute = () => {
  const ability = useAppAbility();

  if (!ability.can("manage", "providerConfigPricingFixed"))
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Restricted />
      </div>
    );

  return (
    <ContractPricingProfilesContextProvider>
      <Outlet />
    </ContractPricingProfilesContextProvider>
  );
};
